(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24133],{

/***/ 69212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefanalysis",
      function () {
        return __webpack_require__(8760);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ DebtReliefAnalysisHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_debtreliefanalysis_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33145);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_debtReliefAnalysisWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19151);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33124);
/* harmony import */ var _components_debtreliefanalysis_faq__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50085);
/* harmony import */ var _components_debtreliefanalysis_howThisWork__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27969);








var __N_SSP = true;
function DebtReliefAnalysisHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_debtReliefAnalysisWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefanalysis_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    padding: "0 15px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefanalysis_howThisWork__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefanalysis_faq__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,19151,24638,49774,92888,40179], function() { return __webpack_exec__(69212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);